import React from 'react'

const CTA = () => {
  return (
    <div className='cta'>
        <a href='https://drive.google.com/file/d/1RrW5HLQvtzX26Y_jgAfGh4lL4XoQ8G_z/view'



        target="_blank"
        rel='noreferrer'
        className='btn'>HIRE ME</a>
        <a href="#contact" className='btn btn-primary'>Let's Talk</a>
    </div>
  )
}

export default CTA;

